const DISMISSAL_KEY_PREFIX =
  "elsa:subscription-billing-banner:dismissed:";

const normalizeId = (value) => {
  const parsedValue = Number(value);
  return Number.isSafeInteger(parsedValue) && parsedValue > 0
    ? parsedValue
    : null;
};

const getStorage = () => {
  try {
    return window.sessionStorage;
  } catch (_error) {
    return null;
  }
};

export const getSubscriptionBillingBannerDismissalKey = (
  userId,
  companyId,
) => {
  const normalizedUserId = normalizeId(userId);
  const normalizedCompanyId = normalizeId(companyId);
  if (!normalizedUserId || !normalizedCompanyId) return null;

  return `${DISMISSAL_KEY_PREFIX}${normalizedUserId}:${normalizedCompanyId}`;
};

export const isSubscriptionBillingBannerDismissed = (
  userId,
  companyId,
) => {
  const key = getSubscriptionBillingBannerDismissalKey(userId, companyId);
  if (!key) return false;

  try {
    return getStorage()?.getItem(key) === "1";
  } catch (_error) {
    return false;
  }
};

export const dismissSubscriptionBillingBanner = (userId, companyId) => {
  const key = getSubscriptionBillingBannerDismissalKey(userId, companyId);
  if (!key) return;

  try {
    getStorage()?.setItem(key, "1");
  } catch (_error) {
    // Le composant conserve aussi l'état en mémoire lorsque le stockage de
    // session est indisponible.
  }
};

export const clearSubscriptionBillingBannerDismissal = (
  userId,
  companyId,
) => {
  const key = getSubscriptionBillingBannerDismissalKey(userId, companyId);
  if (!key) return;

  try {
    getStorage()?.removeItem(key);
  } catch (_error) {
    // Aucun nettoyage supplémentaire n'est nécessaire.
  }
};

export const clearSubscriptionBillingBannerDismissals = () => {
  const storage = getStorage();
  if (!storage) return;

  try {
    const keysToDelete = [];
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (key?.startsWith(DISMISSAL_KEY_PREFIX)) {
        keysToDelete.push(key);
      }
    }
    keysToDelete.forEach((key) => storage.removeItem(key));
  } catch (_error) {
    // Le prochain montage affichera la bannière si le stockage est bloqué.
  }
};

